module.exports = __webpack_public_path__ + "img/shoot-3.ef2341ba.jpg";